module.exports = __webpack_public_path__ + "static/media/chart-pie-alt.0b2d0a0f.svg";